<template>
  <el-dialog
    title="医生信息概要"
    :visible.sync="dialogdata"
    width="800px"
    style="text-align: left"
    :close-on-click-modal="false"
    @open="opendialog"
  >
    <div style="padding: 20px">
      <div style="font-weight: 700; font-size: 15px">基本信息</div>
      <div class="box">
        <div class="flex">
          <div class="item">
            <span class="gray">医生姓名</span>
            <span>{{ info.doctor_name }}</span>
            <span class="gray" style="width: 80px">手机号</span>
            <span>{{ info.phone }}</span>
            <img
              v-if="
                info.phone &&
                (module_id_array[0] ? module_id_array.includes('1756') : true)
              "
              class="phone-box"
              src="https://qhyg-test-1258702188.cos.ap-chengdu.myqcloud.com/upload/common/20240521/171627515049458.png"
              alt
              @click="callBtn(1,info.doctor_id)"
            />
          </div>
          <div class="item">
            <span class="gray">认证时间</span>
            <span>{{ info.update_time }}</span>
          </div>
        </div>
        <div class="item">
          <span class="gray">医生省市</span>
          <span>{{ info.province_name + info.city_name }}</span>
        </div>
        <div class="item">
          <span class="gray">执业医院</span>
          <span>{{ info.hospital }}</span>
        </div>
        <div class="flex">
          <div class="item">
            <span class="gray">最后登录时间</span>
            <span>{{ info.timestamp }}</span>
          </div>
          <div class="item">
            <span class="gray">APP版本号</span>
            <span>{{ info.version }}</span>
          </div>
        </div>
        <div class="flex">
          <div class="item">
            <span class="gray">诊后管理费上限</span>
            <span>{{ info.proportion_num }}</span>
          </div>
          <div class="item">
            <span class="gray">推荐人</span>
            <span style="margin-right: 16px">{{ info.recommender_name }}</span>
            <span>{{ info.recommender_phone }}</span>
            <img
              v-if="
                info.recommender_phone &&
                (module_id_array[0] ? module_id_array.includes('1756') : true)
              "
              class="phone-box"
              src="https://qhyg-test-1258702188.cos.ap-chengdu.myqcloud.com/upload/common/20240521/171627515049458.png"
              alt
              @click="callBtn(2,info.doctor_id)"
            />
          </div>
        </div>
        <div class="item">
          <span class="gray">客服备注</span>
          <span>{{ info.doc_remark }}</span>
        </div>
        <div>
          <span class="gray">问诊咨询</span>
          <span>
            <span style="font-weight: 700"> 图文咨询 </span>
            <span v-if="info.reception == 2">咨询开启</span>
            <span v-else>咨询关闭</span>
          </span>
          <span style="font-weight: 700; margin: 0 10px">|</span>
          <span>
            <span style="font-weight: 700"> 电话问诊 </span>
            <span v-if="info.is_phone_consult == 1" style="margin-right: 10px"
              >权限开启</span
            >
            <span v-else style="margin-right: 10px">权限关闭</span>
            <span v-if="info.phone_consult == 1">咨询开启</span>
            <span v-else>咨询关闭</span>
          </span>
          <span style="font-weight: 700; margin: 0 10px">|</span>
          <span>
            <span style="font-weight: 700"> 视频问诊 </span>
            <span v-if="info.is_video_consult == 1" style="margin-right: 10px"
              >权限开启</span
            >
            <span v-else style="margin-right: 10px">权限关闭</span>
            <span v-if="info.video_consult == 1">咨询开启</span>
            <span v-else>咨询关闭</span>
          </span>
        </div>
      </div>
      <div style="text-align: right">
        <el-button
          type="primary"
          @click="close"
          style="width: 92px"
          size="medium"
          >确定</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>
<script>
import dayjs from "dayjs";
export default {
  data() {
    return {
      dialogdata: false,
      info: {},
    };
  },
  watch: {
    isFlag() {
      if (!this.module_id_array[0] || this.module_id_array.includes("990")) {
        this.dialogdata = true;
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  props: ["isFlag", "doctorId"],
  methods: {
    //提交
    close() {
      this.dialogdata = false;
    },
    opendialog() {
      let doctor_id = this.doctorId;
      this.axios
        .post("platform/doctor/getDoctorAbstractInfo", { doctor_id })
        .then((res) => {
          if (res.code == 0) {
            this.info = res.data.info;
            this.info.update_time = this.info.update_time
              ? dayjs.unix(this.info.update_time).format("YYYY-MM-DD HH:mm")
              : "";
            this.info.timestamp = this.info.deviceid_msg.timestamp
              ? dayjs
                  .unix(this.info.deviceid_msg.timestamp)
                  .format("YYYY-MM-DD HH:mm")
              : "";
            this.info.version = this.info.deviceid_msg.version;
            let proportion = "";
            if (this.info.proportion.length) {
              proportion =
                this.info.proportion[0].hospital_name +
                " " +
                this.info.proportion[0].drug_type_name +
                " " +
                this.info.proportion[0].proportion;
            } else {
              proportion =
                this.info.default_proportion[0].hospital_name +
                " " +
                this.info.default_proportion[0].drug_type_name +
                " " +
                this.info.default_proportion[0].default_proportion;
            }
            this.info.proportion_num = proportion;
            this.info.recommender_phone = this.info.recommender_info.phone;
            this.info.recommender_name =
              this.info.recommender_info.recommender_name;
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.box {
  border: solid 1px #cfcece;
  padding: 14px;
  box-sizing: border-box;
  margin: 20px 0;
}
.gray {
  color: #747981;
  display: inline-block;
  width: 100px;
  text-align: right;
  margin-right: 10px;
}
.item {
  display: flex;
  flex: 1;
  align-items: center;
  margin-bottom: 10px;
}
.phone-box {
  width: 18px;
  height: 18px;
  padding: 0 6px;
  cursor: pointer;
}
</style>
